export default "__VITE_ASSET__dc7336ff__"